"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlatformConfigurationService = void 0;
var lodash_1 = require("lodash");
var Types_1 = require("./Types");
var UrlAdapter_1 = require("./UrlAdapter");
var LocalAdapter_1 = require("./LocalAdapter");
var PostMessageAdapter_1 = require("./PostMessageAdapter");
var GravityGatewayAdapter_1 = require("./GravityGatewayAdapter");
var Registry_1 = require("./Registry");
var TenantProductRegistry_1 = require("./TenantProductRegistry");
var PlatformConfigurationService = /** @class */ (function () {
    function PlatformConfigurationService() {
    }
    PlatformConfigurationService.prototype.getConfiguration = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            var checkTime, checkIntervalTime, checkIntervalTimeout, urlAdapter, startConfiguration, messageProtocol, localAdapter, localAdapterConfiguration, tenantProductConfig, product, environment, platformName, platformDataCenter, productName, productId, productUuid, tenantId, applicationName, locale, channelId, betshopId, deviceId, isIntegration, user, ui, layout, localConfig, platformConfig, betslip, scrollButtons, moneyDenominations, clientAdapters, postMessageAdapter_1, gravityGatewayAdapterConfig, gravityGatewayAdapter;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        checkTime = 0;
                        checkIntervalTime = 10;
                        checkIntervalTimeout = (0, lodash_1.defaultTo)(options.platformCheckIntervalTimeout, 5000);
                        urlAdapter = new UrlAdapter_1.UrlAdapter();
                        startConfiguration = urlAdapter.getConfiguration(options);
                        messageProtocol = startConfiguration.messageProtocol;
                        if (!options.includeLocalAdapter) return [3 /*break*/, 2];
                        localAdapter = new LocalAdapter_1.LocalAdapter();
                        return [4 /*yield*/, localAdapter.getConfiguration(options)];
                    case 1:
                        localAdapterConfiguration = _a.sent();
                        (0, lodash_1.merge)(startConfiguration, localAdapterConfiguration);
                        _a.label = 2;
                    case 2:
                        /*
                        Checking and merging specific product configuration per tenant.
                        This is for backward compatability with Playtech URL configuration
                        that should change in the future on Playtech side (set our unified params).
                        */
                        if (startConfiguration.platformConfig && startConfiguration.tenantId) {
                            tenantProductConfig = TenantProductRegistry_1.tenantProductRegistry.tenantProducts[startConfiguration.platformConfig.casino];
                            if (tenantProductConfig) {
                                product = Registry_1.registry.getProduct(startConfiguration.productName);
                                (0, lodash_1.merge)(startConfiguration, (0, lodash_1.omit)(tenantProductConfig, 'products'), tenantProductConfig.products[product.name], {
                                    productName: product.name,
                                });
                            }
                        }
                        environment = startConfiguration.environment;
                        platformName = startConfiguration.platformName;
                        platformDataCenter = startConfiguration.platformDataCenter;
                        productName = startConfiguration.productName;
                        productId = startConfiguration.productId;
                        productUuid = startConfiguration.productUuid;
                        tenantId = startConfiguration.tenantId;
                        applicationName = startConfiguration.applicationName;
                        locale = startConfiguration.locale;
                        channelId = startConfiguration.channelId;
                        betshopId = startConfiguration.betshopId;
                        deviceId = startConfiguration.deviceId;
                        isIntegration = startConfiguration.isIntegration;
                        user = startConfiguration.user;
                        ui = startConfiguration.ui;
                        layout = startConfiguration.layout;
                        localConfig = startConfiguration.localConfig;
                        platformConfig = startConfiguration.platformConfig;
                        betslip = startConfiguration.betslip;
                        scrollButtons = startConfiguration.scrollButtons;
                        moneyDenominations = startConfiguration.moneyDenominations;
                        /*
                        Async adapters that require postMessage protocol.
                        These include: PostMessage, GravityGateway, IFrameResizer.
                        All adapters normalize to postMessage event Configuration:SetConfiguration.
                        */
                        if (window.addEventListener) {
                            window.addEventListener('Configuration:SetConfiguration', (function (event) {
                                if (event.detail) {
                                    var asyncConfiguration = postMessageAdapter_1.parseEventPayload(event.detail);
                                    environment = (0, lodash_1.defaultTo)(asyncConfiguration.environment, environment);
                                    platformName = (0, lodash_1.defaultTo)(asyncConfiguration.platformName, platformName);
                                    platformDataCenter = (0, lodash_1.defaultTo)(asyncConfiguration.platformDataCenter, platformDataCenter);
                                    productName = (0, lodash_1.defaultTo)(asyncConfiguration.productName, productName);
                                    productId = (0, lodash_1.defaultTo)(asyncConfiguration.productId, productId);
                                    productUuid = (0, lodash_1.defaultTo)(asyncConfiguration.productUuid, productUuid);
                                    tenantId = (0, lodash_1.defaultTo)(asyncConfiguration.tenantId, tenantId);
                                    locale = (0, lodash_1.defaultTo)(asyncConfiguration.locale, locale);
                                    applicationName = (0, lodash_1.defaultTo)(asyncConfiguration.applicationName, applicationName);
                                    channelId = (0, lodash_1.defaultTo)(asyncConfiguration.channelId, channelId);
                                    betshopId = (0, lodash_1.defaultTo)(asyncConfiguration.betshopId, betshopId);
                                    deviceId = (0, lodash_1.defaultTo)(asyncConfiguration.deviceId, deviceId);
                                    isIntegration = (0, lodash_1.defaultTo)(asyncConfiguration.isIntegration, isIntegration);
                                    user = (0, lodash_1.defaultTo)(asyncConfiguration.user, user);
                                    ui = (0, lodash_1.defaultTo)(asyncConfiguration.ui, ui);
                                    layout = (0, lodash_1.defaultTo)(asyncConfiguration.layout, layout);
                                    betslip = (0, lodash_1.defaultTo)(asyncConfiguration.betslip, betslip);
                                    scrollButtons = (0, lodash_1.defaultTo)(asyncConfiguration.scrollButtons, scrollButtons);
                                    moneyDenominations = (0, lodash_1.defaultTo)(asyncConfiguration.moneyDenominations, moneyDenominations);
                                }
                            }), {
                                once: true,
                            });
                            clientAdapters = (0, lodash_1.defaultTo)(options.clientAdapters, []);
                            postMessageAdapter_1 = new PostMessageAdapter_1.PostMessageAdapter();
                            postMessageAdapter_1.getConfiguration();
                            if (messageProtocol === Registry_1.registry.messageProtocols.gravityGateway.name) {
                                gravityGatewayAdapterConfig = clientAdapters.find(function (clientAdapter) { return clientAdapter.name === 'GravityGatewayAdapter'; });
                                gravityGatewayAdapter = new GravityGatewayAdapter_1.GravityGatewayAdapter(gravityGatewayAdapterConfig ? gravityGatewayAdapterConfig.options : { slaveId: productId });
                                gravityGatewayAdapter.getConfiguration();
                            }
                        }
                        return [2 /*return*/, new Promise(function (resolve, reject) {
                                var checkInterval = setInterval(function () {
                                    if ((0, lodash_1.isString)(productId)) {
                                        clearInterval(checkInterval);
                                        resolve({
                                            environment: environment,
                                            platformName: platformName,
                                            platformDataCenter: platformDataCenter,
                                            productId: productId,
                                            productUuid: productUuid,
                                            productName: productName,
                                            tenantId: tenantId,
                                            locale: locale,
                                            applicationName: applicationName,
                                            messageProtocol: messageProtocol,
                                            channelId: channelId,
                                            betshopId: betshopId,
                                            deviceId: deviceId,
                                            isIntegration: isIntegration,
                                            localConfig: localConfig,
                                            platformConfig: platformConfig,
                                            user: user,
                                            ui: ui,
                                            layout: layout,
                                            betslip: betslip,
                                            scrollButtons: scrollButtons,
                                            moneyDenominations: moneyDenominations,
                                        });
                                    }
                                    else {
                                        checkTime += checkIntervalTime;
                                        if (checkTime > checkIntervalTimeout) {
                                            clearInterval(checkInterval);
                                            reject(Types_1.ConfigurationErrors.PlatformTimeoutError);
                                        }
                                    }
                                }, checkIntervalTime);
                            })];
                }
            });
        });
    };
    return PlatformConfigurationService;
}());
exports.PlatformConfigurationService = PlatformConfigurationService;
//# sourceMappingURL=PlatformConfigurationService.js.map